const checkLikedOrAddedToCardTour = (tourId, toursList) => {
  let geokey = null;
  toursList.map( tour => {
    if (+tour.tour_id === +tourId) {
      geokey = tour.geokey;
    }
  })
  return geokey;
}
export default checkLikedOrAddedToCardTour;